import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

// import NavBar from "./components/NavBar";
import PageContainer from "./components/PageContainer";

import Home from "./pages/Home";
import Feature1 from "./pages/Feature1";
import Feature2 from "./pages/Feature2";
import Feature3 from "./pages/Feature3";
import Feature4 from "./pages/Feature4";
import Feature5 from "./pages/Feature5";
import Feature6 from "./pages/Feature6";
import Feature7 from "./pages/Feature7";
import Feature8 from "./pages/Feature8";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>PCG SLABS Features</h1>
        <p>Use the links below to navigate each feature update.</p>

        {/* Shared top navigation */}
        {/* <NavBar /> */}

        {/* The main routed content area uses CRA colors and spacing */}
        <PageContainer>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/feature1" element={<Feature1 />} />
            <Route path="/feature2" element={<Feature2 />} />
            <Route path="/feature3" element={<Feature3 />} />
            <Route path="/feature4" element={<Feature4 />} />
            <Route path="/feature5" element={<Feature5 />} />
            <Route path="/feature6" element={<Feature6 />} />
            <Route path="/feature7" element={<Feature7 />} />
            <Route path="/feature8" element={<Feature8 />} />
            {/* Optional: a catch-all route could go here */}
          </Routes>
        </PageContainer>

        <h2>
          This app is a catalog of feature pages for a future website.
        </h2>
      </header>
    </div>
  );
}

export default App;
